import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from '@env/environment';
import { UserType } from '@app/auth';

@Injectable({
  providedIn: 'root',
})
export class ResourcesService {

  constructor(
    private httpClient: HttpClient,
  ) {}

  getResource(userType: UserType): any {
    switch(userType) {
      default:
        return {
          whatsNew: environment.publicWhatsNew,
          apiUserGuide: `${environment.publicPolicyBaseUrl}/api/`,
          termsConditions: `${environment.basePath}/sectioned-blog-viewer/${environment.resources.termsAndConditions}`,
          privacyPolicy: `${environment.basePath}/sectioned-blog-viewer/${environment.resources.privacyPolicy}`,
          cookiePolicy: `${environment.basePath}/sectioned-blog-viewer/${environment.resources.cookiePolicy}`,
          dataProtection: `${environment.basePath}/sectioned-blog-viewer/${environment.resources.dataProtectionAgreement}`,
          listOfSubprocesses: `${environment.listOfSubprocessesUrl}`,
          exportControl: `${environment.basePath}/sectioned-blog-viewer/${environment.resources.exportControl}`
        }
    }
  }

  getPreLoginPageBanners(): Observable<Object> {
    const headers = new HttpHeaders().set('Accept', 'application/json');
    return this.httpClient.get(environment.preLoginPageBannerMessageUrl, { headers });
  }
}
